// extracted by mini-css-extract-plugin
module.exports = {"large":"input_large__37oHO","medium":"input_medium__1kwMM","small":"input_small__2piNa","mobile":"input_mobile__GcyC7"};